<template>
  <div v-if="!isFetchingCustomer">
    <v-card elevation="0" class="ma-sm-5">
      <v-card-text>
        <v-form ref="form">
            <v-tabs
                color="primary"
                centered
                ref="tabs"
                v-model="currentTab"
                :show-arrows="true"
            >
              <v-tab key="general">
                <v-icon class="mr-3">home</v-icon>
                {{ $t('common:general') }}
              </v-tab>
              <v-tab key="functions">
                <v-icon class="mr-3">settings</v-icon>
                {{ $t('common:additional') }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="currentTab">
              <v-tab-item key="general" eager>
                <GeneralTab :customer="data" @updateCustomer="(updatedData) => data = updatedData" />
              </v-tab-item>
              <v-tab-item key="additionalInfoTab" eager>
                <AdditionalInfoTab :customer="data" @updateCustomer="(updatedData) => data = updatedData" />
              </v-tab-item>
            </v-tabs-items>

            <BaseButton
                color="primary"
                :btn-text="$t('buttons:save')"
                @clickedButton="updateCustomer()"
            />
            <v-col class="d-none d-md-block" md="2"></v-col>

        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Customer from '@/modules/core/data/customer';
import CustomerService from '@/modules/core/services/customer-service';
import Utils from '@/modules/core/services/utils';
import {ruleRequired} from '@/modules/core/services/rules';
import DataUtils from '@/modules/core/services/data-utils';
import BaseButton from "@/modules/core/components/Base/BaseButton";
import GeneralTab from '@/modules/settings/views/profile/customer-profile-tab/GeneralTab';
import AdditionalInfoTab from '@/modules/settings/views/profile/customer-profile-tab/AdditionalInfoTab';

export default {
  name: "CustomerSettings",
  components: {
    AdditionalInfoTab,
    GeneralTab,
    BaseButton
  },
  data() {
    return {
      data: new Customer(),
      countries: [],
      currentTab: {},
      isFetchingCustomer: true
    }
  },
  methods: {

    updateCustomer() {
      if (!this.$refs.form.validate()) {
        return;
      }

      CustomerService.putProfileToAPI(this.data,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('settings/profile:customer.settings.snackbar.settings')}));
          this.$router.go(-1)
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('settings/profile:customer.settings.snackbar.settings')}))
        }
      )
    },
    ruleRequired,




  },
  computed: {
    currentLang() {
      return this.$store.state.translation.language;
    }
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        Utils.translateAllCountries(this.countries)
        Utils.translateAllProvinces(this.countries,this.provinces,this.data.country);
        this.$refs.form.resetValidation()
      });
    },
  },
  created() {
    CustomerService.readProfileFromAPI(
      (resp) => {
        var response = DataUtils.parseDataToSingleObject(resp.data, Customer);
        if (response == null) {
          this.$logger.error("Failed to receive customer settings!");
          this.$router.go(-1);
        } else {
          this.data = response;
          if (!this.data.country) {
            this.data.country = this.countries[0].id
          }
          this.isFetchingCustomer = false;
        }
      },
      (error) => {
        this.$router.push('/404')
        this.$logger.error(error);
      }
    )
  }
}
</script>
